export const UPDATE_HAVE_FIXED_WIRE = 'UPDATE_HAVE_FIXED_WIRE';
export const UPDATE_ORDER_UPPER_ARCH_RETAINER = 'UPDATE_ORDER_UPPER_ARCH_RETAINER';
export const UPDATE_ORDER_LOWER_ARCH_RETAINER = 'UPDATE_ORDER_LOWER_ARCH_RETAINER';
export const UPDATE_CLEAR_UPPER_ARCH_RETAINER = 'UPDATE_CLEAR_UPPER_ARCH_RETAINER';
export const UPDATE_CLEAR_LOWER_ARCH_RETAINER = 'UPDATE_CLEAR_LOWER_ARCH_RETAINER';
export const UPDATE_SETUP_INSTRUCT_UPPER_ARCH_RETAINER = 'UPDATE_SETUP_INSTRUCT_UPPER_ARCH_RETAINER';
export const UPDATE_SETUP_INSTRUCT_LOWER_ARCH_RETAINER = 'UPDATE_SETUP_INSTRUCT_LOWER_ARCH_RETAINER';
export const UPDATE_BITE_RAMPS = 'UPDATE_BITE_RAMPS';

export const UPDATE_UPLOAD_IMPRESSION_ARCH = 'UPDATE_UPLOAD_IMPRESSION_ARCH';

export const UPDATE_UPPER_ORDER_RETAINES_ARR = 'UPDATE_UPPER_ORDER_RETAINES_ARR';
export const UPDATE_LOWER_ORDER_RETAINES_ARR = 'UPDATE_LOWER_ORDER_RETAINES_ARR';

export const ADD_UPPER_ORDER_RETAINERS_OBJ = 'ADD_UPPER_ORDER_RETAINERS_OBJ';
export const ADD_LOWER_ORDER_RETAINERS_OBJ = 'ADD_LOWER_ORDER_RETAINERS_OBJ';

export const EDIT_UPPER_ORDER_RETAINERS_OBJ = 'EDIT_UPPER_ORDER_RETAINERS_OBJ';
export const EDIT_LOWER_ORDER_RETAINERS_OBJ = 'EDIT_LOWER_ORDER_RETAINERS_OBJ';

export const DELETE_UPPER_ORDER_RETAINERS_OBJ = 'DELETE_UPPER_ORDER_RETAINERS_OBJ';
export const DELETE_LOWER_ORDER_RETAINERS_OBJ = 'DELETE_LOWER_ORDER_RETAINERS_OBJ';

export const SET_SUPPROTED_RETAINTER_TYPES = 'SET_SUPPROTED_RETAINTER_TYPES';

export const SAVE_FORM_VALUES = 'SAVE_FORM_VALUES';
export const UPDATE_FORM_ERROR = 'UPDATE_FORM_ERROR';
export const RESET_FORM_VALUES = 'RESET_FORM_VALUES';

export const SET_TOOTH_SELECTIONS = 'SET_TOOTH_SELECTIONS';
export const RESET_TOOTH_SELECTIONS = 'RESET_TOOTH_SELECTIONS';
export const RESET_SINGLE_TOOTH_SELECTIONS = 'RESET_SINGLE_TOOTH_SELECTIONS';

export const SET_QUESTIONS = 'SET_QUESTIONS';

export const SET_ENABLE_ORDER_DIFFERENT_RETAINER = 'SET_ENABLE_ORDER_DIFFERENT_RETAINER';

export const SET_TARGET_TYPE_FORM_VALIDATION_FUNC = 'SET_TARGET_TYPE_FORM_VALIDATION_FUNC';

export const SAVE_IMPRESSION_TYPE_FORM_VALUES = 'SAVE_IMPRESSION_TYPE_FORM_VALUES';

export const SET_SINGLE_TYPE_BITE_RAMP_TEETH_SELECTIONS = 'SET_SINGLE_TYPE_BITE_RAMP_TEETH_SELECTIONS';

export const SET_SPECIAL_INSTRUCTION = 'SET_SPECIAL_INSTRUCTION';

export const SET_RETAINER_REQ_ID = 'SET_RETAINER_REQ_ID';

export const SET_BOTH_UPPER_TYPE_BITE_RAMP_TEETH_SELECTIONS = 'SET_BOTH_UPPER_TYPE_BITE_RAMP_TEETH_SELECTIONS';

export const SET_BOTH_LOWER_TYPE_BITE_RAMP_TEETH_SELECTIONS = 'SET_BOTH_LOWER_TYPE_BITE_RAMP_TEETH_SELECTIONS';
